import React from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { customTableStylesReport, fallbackIfEmpty } from "utils/Utils";
import styles from "containers/Reports/ReportsLearningTraining/styles.module.scss";

const Table = ({ data, loading, actionFilter, totalRecords }) => {
  const columns = [
    {
      name: "Título da Avaliação",
      selector: "Título da avaliação",
      sortable: true,
      center: true,
      wrap: true,
      width: "220px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Título da avaliação"]),
    },
    {
      name: "Média de Acertos",
      selector: "Média de acertos avaliação",
      sortable: true,
      center: true,
      wrap: true,
      width: "150px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Média de acertos avaliação"]),
    },
    {
      name: "Qtd. Respondentes Avaliação",
      selector: "Qtd. de respondentes da avaliação",
      sortable: true,
      center: true,
      wrap: true,
      width: "120px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Qtd. de respondentes da avaliação"]),
    },
    {
      name: "Enunciado da Questão",
      selector: "Enunciado da questão",
      sortable: true,
      center: true,
      wrap: true,
      width: "220px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Enunciado da questão"]),
    },
    {
      name: "Tipo de Questão",
      selector: "Tipo de Questão",
      sortable: true,
      center: true,
      wrap: true,
      width: "150px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Tipo de Questão"]),
    },
    {
      name: "Qtd. Alternativas",
      selector: "Qtd. de Alternativas",
      sortable: true,
      center: true,
      wrap: true,
      width: "100px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Qtd. de Alternativas"]),
    },
    {
      name: "Qtd. Respondentes Questão",
      selector: "Qtd. de Respondentes da questão",
      sortable: true,
      center: true,
      wrap: true,
      width: "120px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Qtd. de Respondentes da questão"]),
    },
    {
      name: "Nº de Acertos",
      selector: "Nº de Acertos",
      sortable: true,
      center: true,
      wrap: true,
      width: "100px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Nº de Acertos"]),
    },
    {
      name: "% Acerto Geral",
      selector: "% Acerto Geral",
      sortable: true,
      center: true,
      wrap: true,
      width: "120px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["% Acerto Geral"]),
    },
    {
      name: "Gabarito",
      selector: "Gabarito",
      sortable: true,
      center: true,
      wrap: true,
      width: "100px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Gabarito"]),
    },
    ...Array.from({ length: 10 }).map((_, idx) => ({
      name: `Qtd. respostas opção ${idx + 1}`,
      selector: `Qtd. respostas opção ${idx + 1}`,
      sortable: false,
      center: true,
      wrap: true,
      width: "70px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d[`Qtd. respostas opção ${idx + 1}`]),
    })),
    // Alternativas e respostas
    ...Array.from({ length: 10 }).map((_, idx) => ({
      name: `Texto Opção ${idx + 1}`,
      selector: `Texto opção ${idx + 1}`,
      sortable: false,
      center: true,
      wrap: true,
      width: "300px",
      style: { textAlign: "center" },
      cell: (d) =>
        d[`Texto opção ${idx + 1}`] ? (
          <div>
            <div dangerouslySetInnerHTML={{ __html: d[`Texto opção ${idx + 1}`] }} />
          </div>
        ) : (
          "-"
        ),
    })),
  ];

  const tableData = {
    columns,
    data,
  };

  const paginationComponentOptions = {
    rowsPerPageText: "Registros por página",
    rangeSeparatorText: "de",
  };

  const onChangePage = (page, totalRows) => {
    actionFilter({ offset: --page * data.length });
  };

  const onChangeRowsPerPage = (limit) => {
    actionFilter({ limit, offset: 0 });
  };

  const loadingComponent = () => (
    <div className="tela-login-loading">
      <div className="loader-container" style={{ margin: "300px 0" }}>
        <div
          style={{
            position: "initial",
            margin: "initial",
          }}
          className="loader loader-center loader-big"
        ></div>
        <span
          style={{
            marginTop: 10,
            fontSize: 20,
          }}
        >
          Carregando dados...
        </span>
      </div>
    </div>
  );

  return (
    <DataTableExtensions
      filter={false}
      print={false}
      {...tableData}
      exportHeaders={true}
      export={false}
    >
      <DataTable
        columns={columns}
        data={data}
        className={styles.dataTableFormat}
        customStyles={customTableStylesReport}
        progressPending={loading}
        progressComponent={loadingComponent()}
        noHeader={true}
        noDataComponent="Não foi encontrado nenhum dado consolidado"
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        paginationTotalRows={totalRecords}
        paginationComponentOptions={paginationComponentOptions}
        paginationServer
        pagination
      />
    </DataTableExtensions>
  );
};

export default Table;
